<div #propertyCardContainer>
  <div [ngClass]="{ 'no-box-shadow': compData?.container?.hideBoxShadow }" class="header-card ion-no-margin">
    <div [ngClass]="{ 'no-padding-start': compData?.container?.hideBoxShadow }" class="header-wrap">
      <div>
        @if (compData?.container?.image?.path) {
          <div [ngStyle]="{ width: compData?.container?.image?.width }"
               class="image-settings">
            <img [height]="compData?.container?.image?.height"
                 [ngSrc]="compData?.container?.image?.path"
                 [alt]="compData?.container?.image?.alt" width="100" height="100" loading="lazy">
          </div>
        }
        <div class="rating-wrap">
          <div class="rating-flx-wrap">
            <div class="property-header-wrap">
              <div class="title-card">
                <div class="rating-n-assured">

                  @if (filledStars?.length > 0) {
                    <div class="stars-section flex-container ion-align-items-center">
                      <!--filled star-->
                      @for (star of filledStars; track star) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                          <path
                            d="M12 2L9.34 8.5L2 9.5L7.5 14L6.17 20L12 17L17.83 20L16.5 14L22 9.5L14.66 8.5L12 2Z"
                            fill="#ffc800"/>
                          <path
                            d="M12 2L9.34 8.5L2 9.5L7.5 14L6.17 20L12 17L17.83 20L16.5 14L22 9.5L14.66 8.5L12 2Z"
                            stroke="#ffc800" fill="none"/>
                        </svg>
                      }
                      <!--half-filled star-->
                      @if (decimalStar) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                          <defs>
                            <linearGradient id="half-fill-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                              <stop offset="50%" style="stop-color: #ffc800; stop-opacity: 1"/>
                              <stop offset="50%" style="stop-color: transparent; stop-opacity: 1"/>
                            </linearGradient>
                          </defs>
                          <path
                            d="M12 2L9.34 8.5L2 9.5L7.5 14L6.17 20L12 17L17.83 20L16.5 14L22 9.5L14.66 8.5L12 2Z"
                            fill="url(#half-fill-gradient)" stroke="#ffc800"/>
                        </svg>
                      }
                      <!--unfilled star-->
                      @for (star of emptyStars; track star) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                          <path
                            d="M12 2L9.34 8.5L2 9.5L7.5 14L6.17 20L12 17L17.83 20L16.5 14L22 9.5L14.66 8.5L12 2Z"
                            fill="none" stroke="#777777"/>
                        </svg>
                      }
                    </div>
                  }
                  @if (compData?.container?.isB2bCertified) {
                    <div class="certified-wrap dsp-badge" (click)="toggleCertified($event)"
                         [ngStyle]="{'background': 'linear-gradient(95.1deg, rgb(1, 5, 103) 0%, rgb(26, 85, 155) 100%)'}">
                      <div class="certified-b-img">
                        <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/bag2bag-certified.png'"
                             alt="bag2bag-certified" width="100" height="100" loading="lazy">
                      </div>
                      <span class="badge-text" [ngStyle]="{'color': '#ffffff'}">Certified</span>
                      @if (isVisible) {
                        <div class="cerInfo" #popupRef (click)="$event.stopPropagation()">
                          <div class="imgBlk">
                            <div class="cerImg">
                              <img
                                [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/bag2bag-certified.png'"
                                alt="bag2bag-certified" width="100" height="100" loading="lazy">
                            </div>
                            <div class="cerTitle">
                              {{ compData?.container?.certifiedContainer?.title }}
                              <!--Top Rated Affordable Properties-->
                            </div>
                          </div>
                          <div class="cerNotes">
                            <div class="desc"
                                 [innerHTML]="compData?.container?.certifiedContainer?.description | safe:'html'"></div>
                            <div class="flex-container ion-align-items-center ion-justify-content-end link">
                              <a [routerLink]="compData?.container?.certifiedContainer?.navigationURL" target="_blank">Learn
                                More</a>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }

                </div>
                <div class="hotel-title">
                  <div class="rating-title">
                    <div class="title">
                      {{ compData?.container?.displayName | titlecase }}
                    </div>
                  </div>
                </div>
                <div [ngClass]="{ 'no-padding-start': compData?.container?.hideBoxShadow }" class="content-description">
                  @if (compData?.container?.description) {
                    <div
                      [innerHTML]="compData?.container?.description | safe: 'html'" class="description-address">
                    </div>
                  }
                </div>
              </div>
              @if (compData?.pc1?.textList?.length > 0) {
                <div class="ofr-bnr">
                  <div class="ofr-icon">
                    <svg width="12px" height="12px" viewBox="0 0 20 20"
                         xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd"
                            d="M11.566.66a2.189 2.189 0 00-3.132 0l-.962.985a2.189 2.189 0 01-1.592.66l-1.377-.017a2.189 2.189 0 00-2.215 2.215l.016 1.377a2.189 2.189 0 01-.66 1.592l-.984.962a2.189 2.189 0 000 3.132l.985.962c.428.418.667.994.66 1.592l-.017 1.377a2.189 2.189 0 002.215 2.215l1.377-.016a2.189 2.189 0 011.592.66l.962.984c.859.88 2.273.88 3.132 0l.962-.985a2.189 2.189 0 011.592-.66l1.377.017a2.189 2.189 0 002.215-2.215l-.016-1.377a2.189 2.189 0 01.66-1.592l.984-.962c.88-.859.88-2.273 0-3.132l-.985-.962a2.189 2.189 0 01-.66-1.592l.017-1.377a2.189 2.189 0 00-2.215-2.215l-1.377.016a2.189 2.189 0 01-1.592-.66L11.566.66zM7 8.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm6 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm.778-8.278a1.1 1.1 0 010 1.556l-6 6a1.1 1.1 0 11-1.556-1.556l6-6a1.1 1.1 0 011.556 0z"
                            fill="#FF6B00"></path>
                    </svg>
                  </div>
                  <div>
                    @for (offer of compData?.pc1?.textList; track offer) {
                      <div class="ofr-txt" [innerHTML]="offer | safe: 'html'"></div>
                    }
                  </div>
                </div>
              }
            </div>
            <div class="rating-container">
              @if (compData?.container?.vendorAverageFeedback?.averageRating > 0 || compData?.container?.rating > 0) {
                <div
                  class="rating-inner-wrap">
                  <!--b2b rating-->
                  @if (compData?.container?.vendorAverageFeedback?.averageRating > 0) {
                    <div class="b2b-rating">
                      <div class="rating-count">
                        <div class="rating-info">
                          <div class="star-icon">
                            <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/logo/b2b-fav-icon.webp'"
                                 alt="google"
                                 width="15" height="24" loading="lazy">
                          </div>
                        </div>
                        <div class="rating">
                          <div class="rating-cnt">
                            {{ compData?.container?.vendorAverageFeedback?.averageRating | number : '1.1-1' }}
                          </div>
                          <div class="votes-count mob-count">
                            <p>{{ compData?.container?.vendorAverageFeedback?.averageRating | ratingType }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="votes-count web-count">
                        <p>{{ compData?.container?.vendorAverageFeedback?.averageRating | ratingType }}</p>
                      </div>
                    </div>
                  }
                  <!--google rating-->
                  @if (compData?.container?.rating > 0) {
                    <div class="glg-rating">
                      <div class="rating-count">
                        <div class="rating-info">
                          <div class="star-icon">
                            <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/google.webp'"
                                 alt="google" width="18" height="25" loading="lazy">
                          </div>
                        </div>
                        <div class="rating">
                          <div class="rating-cnt">
                            {{ compData?.container?.rating | number : '1.1-1' }}
                          </div>
                          <div class="votes-count mob-count">
                            <p>{{ compData?.container?.rating | ratingType }}
                              <!--                          <span>({{ compData?.container?.votes + ' Google Reviews' }})</span>-->
                            </p>
                          </div>
                        </div>
                      </div>
                      @if (compData?.container?.votes > 0) {
                        <div class="votes-count web-count">
                          <p>{{ compData?.container?.rating | ratingType }}
                            <!--                      <span>({{ compData?.container?.votes + ' Google Reviews' }})</span>-->
                          </p>
                        </div>
                      }
                    </div>
                  }

                  @if (compData?.container?.vendorAverageFeedback?.count > 0 || compData?.container?.votes > 0) {
                    <div class="all-rating">
                      <button (click)="gotoReviews()" tapEffect>
                        See All Reviews
                      </button>
                    </div>
                  }
                </div>
              }
              <div class="web-booking-option">
                <div class="flex-container ion-align-items-center">
                  <div class="like-wrap">
                    <div class="blog-content-img">
                      <button (click)="toggleFavorite()"
                              [class.favorite-btn]="isFavorite"
                              [class.unfavorite-btn]="!isFavorite"
                              class="fav-wrap" tapEffect
                      >
                      </button>
                    </div>
                  </div>
                  <div (click)="openShareModal()" class="share-option" tapEffect>
                    <img alt="share" height="100"
                         [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/share.webp'"
                         width="100">
                  </div>
                </div>
                <div class="book-now">
                  <button (click)="gotoRooms()" class="book-now-btn" tapEffect>Book Now</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



@if (compData?.container?.hotelListSchema
&& compData?.container?.hotelListSchema?.url) {
  <div class="hidden">
    <div itemscope="" itemtype="http://schema.org/Hotel">
      <span itemprop="name">{{ compData?.container?.hotelListSchema?.name }}</span>
      @if (compData?.container?.ratingAndReviewConfig?.rating > 0) {
        <div
          itemprop="aggregateRating" itemscope="" itemtype="http://schema.org/AggregateRating">
          <meta itemprop="ratingValue" content="{{compData?.container?.ratingAndReviewConfig?.rating}}"/>
          <meta itemprop="worstRating" content="1"/>
          <meta itemprop="reviewCount" content="{{compData?.container?.ratingAndReviewConfig?.votes}}"/>
          <meta itemprop="bestRating" content="5"/>
        </div>
      }
      <div itemprop="address" itemscope="" itemtype="http://schema.org/PostalAddress">
        <span itemprop="addressLocality">{{ compData?.container?.hotelListSchema?.address?.addressLocality }}</span>
        <span itemprop="addressRegion">{{ compData?.container?.hotelListSchema?.address?.addressRegion }}</span>
        <span itemprop="addressCountry">{{ compData?.container?.hotelListSchema?.address?.addressCountry }}</span>
        <span itemprop="streetAddress">{{ compData?.container?.hotelListSchema?.address?.streetAddress }}</span>
        <span itemprop="postalCode">{{ compData?.container?.hotelListSchema?.address?.postalCode }}</span>
      </div>
      <meta itemprop="priceRange" content="{{  compData?.container?.hotelListSchema?.priceRange }}"/>
      <meta itemprop="telephone" content="{{ compData?.container?.hotelListSchema?.telephone }}"/>
      <meta itemprop="url" content="{{ compData?.container?.hotelListSchema?.url }}"/>
      <meta itemprop="email" content="{{ compData?.container?.hotelListSchema?.email }}"/>
      <meta itemprop="image" content="{{ compData?.container?.hotelListSchema?.image }}"/>
      <div itemprop="geo" itemscope="" itemtype="http://schema.org/GeoCoordinates">
        <meta itemprop="latitude" content="{{ compData?.container?.hotelListSchema?.geo?.latitude }}"/>
        <meta itemprop="longitude" content="{{ compData?.container?.hotelListSchema?.geo?.longitude }}"/>
      </div>
    </div>
  </div>
}
